import { render, staticRenderFns } from "./SupervisorsManager.vue?vue&type=template&id=5b7d6126"
import script from "./SupervisorsManager.vue?vue&type=script&lang=js"
export * from "./SupervisorsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports